import React, { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";

/**
 * Password input field with a built-in show/hide eye toggle.
 *
 * Props:
 *   - value, onChange (controlled)
 *   - placeholder, required, autoComplete
 *   - testId (data-testid prefix; eye gets `${testId}-eye`)
 *   - rules (bool) — when true, renders the password-rule hint underneath
 */
export default function PasswordInput({
  value, onChange, placeholder = "Password",
  required = false, autoComplete = "current-password",
  testId = "password-input", rules = false, className = "",
}) {
  const [show, setShow] = useState(false);
  return (
    <div className={className}>
      <div className="relative">
        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA3D4] z-10" size={16} />
        <input
          data-testid={testId}
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required={required}
          autoComplete={autoComplete}
          className="w-full pl-9 pr-10 py-3 bg-white text-black border border-[#26263A] rounded-xl focus:ring-2 focus:ring-[#7C3AED] outline-none placeholder:text-gray-400 font-mono-num"
        />
        <button
          type="button"
          data-testid={`${testId}-eye`}
          onClick={() => setShow((s) => !s)}
          tabIndex={-1}
          aria-label={show ? "Hide password" : "Show password"}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#9CA3D4] hover:text-[#7C3AED] z-10"
        >
          {show ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
      {rules && (
        <div className="text-[10px] text-[#9CA3D4] mt-1">
          Min 8 characters · 1 uppercase · 1 lowercase · 1 number (special char optional). Example: <span className="font-mono text-[#A78BFA]">Abrantie@1</span>
        </div>
      )}
    </div>
  );
}
